import React from "react";
import { ILoginService, LoginService } from '../../services/LoginService'

export interface LoginProps {
    loginService: ILoginService;
}

export const LoginContext = React.createContext<LoginProps>({
    loginService: new LoginService(u => true)
})
